<template>
    <div 
        class="o-t-transport-types"
        :style="styles"
    >
        <div class="o-t-transport-types__name-wrapper">
            <div class="o-t-transport-types__icon">
                <img
                    alt="alt"
                    :src="activeTransportType.files.icon"
                >
            </div>
            <div class="o-t-transport-types__name">
                {{title}}
            </div>
        </div>
        <div class="o-t-transport-types__types-wrapper">
            <div
                :class="[
                    'o-t-transport-types__transport-type',
                    activeTransportType.id === type.id ? 'active' : ''
                ]"
                v-for="type in filrtedPreparedTransports"
                :key="type.id"
                @click="changeTransportType(type)"
            >
                {{type.meta[`name_${getActiveLocale}`]}}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sortBy from 'lodash/sortBy';

export default {
    name: 'OTTransportTypes',
    data() {
        return {
            activeTransportType: null,
            intervalPrepareTransportTypes: null

        }
    },
    watch: {
        getAvailableTransport() {
            this.changeTransportType(this.preparedTransports[0])
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getActiveLocale',
            'getListChildren',
            'getMapConfigProp',
            'getServicesObjects',
            'getAvailableTransport',
            'getObjectsByCategory',
            'getOrderedServiceCategories',
        ]),
        styles() {
            return this.getMapConfigProp('components.OTTransportTypes.styles') || {};
        },
        getTransportServiceCategoryId() {
            return this.getOrderedServiceCategories.filter(service => {
                return service.meta.is_transport;
            })[0].id;
        },
        preparedTransports() {
            return this.getListChildren(this.getTransportServiceCategoryId);
        },
        preparedTransportsWithRuterTransportType() {
            return this.preparedTransports.map((transport) => {
                const transportType = sortBy(this.getObjectsByCategory(+transport.id), ["distance"]) || [];
                const ruterType = this.getAvalibleTransportType(transportType);

                return {...transport, ruter_transport_types: ruterType}
            }) 
        },
        filrtedPreparedTransports() {
            return this.preparedTransportsWithRuterTransportType.filter(transport => 
                this.getAvailableTransport.includes(this.getTransportTypes(transport))
            )
        },
        componentParams() {
            return this.getMapConfigProp('components.OTTransportTypes.params') || {};
        },
        title() {
            if(this.componentParams.is_show_selected_transport_name) {
                return this.t(this.activeTransportType, 'name')
            }
            return this.$t('ui.terminal.transport', 'Transport')
        }
    },
    created() {
        this.filterTransportTypes();

        this.intervalPrepareTransportTypes = setInterval(() => {
            this.filterTransportTypes()
        }, 300000)
    },
    beforeDestroy() {
        if(this.intervalPrepareTransportTypes) clearInterval(this.intervalPrepareTransportTypes)
    },
    methods: {
        ...mapActions([
            'filterTransportTypes'
        ]),
        changeTransportType(item) {
            this.activeTransportType = item;
            this.$emit('changeTransportType', item);
        },
        getTransportTypes(object) {
            return this.t(object, 'ruter_transport_types') || null;
        },
        getAvalibleTransportType(transportTypes) {
            const avalibleTransport = transportTypes.find(transport => {
                const type = this.getTransportTypes(transport)

                return this.getAvailableTransport.includes(type)
            })

            return this.getTransportTypes(avalibleTransport)
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />